import * as z from "zod";
import { mutator } from "./mutator";

export const revealRunData = mutator({
  schema: z.object({ runId: z.string() }),
  resolve: { run: { kind: "run", from: "runId" } },
  permissions: [
    {
      permission: "space:read",
      scopeId: ({ args }) => args.run.workflow.spaceId,
    },
  ],
  description:
    "Triggered when a user views a run that used another person’s connected account.",
  interactionType: "view",
  fn: async () => {},
});
